import { render, staticRenderFns } from "./ProjectsLayout.vue?vue&type=template&id=5d16b572"
import script from "./ProjectsLayout.vue?vue&type=script&lang=js"
export * from "./ProjectsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d16b572')) {
      api.createRecord('5d16b572', component.options)
    } else {
      api.reload('5d16b572', component.options)
    }
    module.hot.accept("./ProjectsLayout.vue?vue&type=template&id=5d16b572", function () {
      api.rerender('5d16b572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/layout/ProjectsLayout.vue"
export default component.exports